import { css, html } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { when } from "lit/directives/when.js";
import { CLOSE_EVENT_NAME, OPEN_EVENT_NAME } from "../../configuration/constants.js";
import { defineComponent } from "../../configuration/utils.js";
import { NavItem } from "./NavItem.js";
export class PlatformSection extends NavItem {
    constructor() {
        super();
        this.handleClick = (e) => {
            e.preventDefault();
            this.dispatchToggleEvent(!this.isOpen);
        };
        this.isOpen = false;
        this.hideSummary = false;
    }
    render() {
        return html `
      <details ?open=${this.isOpen}>
        <summary
          class=${classMap(this.itemClasses)}
          aria-label=${this.label}
          title=${this.label}
          @click=${this.handleClick}
          ?hidden=${this.hideSummary}
        >
          ${when(this.isOpen, this.renderExpandLeftIcon, () => html `<slot name="icon"></slot>`)}
          <span class="label">${this.label}</span>
          ${when(!this.isOpen, this.renderExpandRightIcon)}
        </summary>
        <ul>
          <slot></slot>
        </ul>
      </details>
    `;
    }
    dispatchToggleEvent(newState) {
        if (newState) {
            this.dispatchEvent(new CustomEvent(OPEN_EVENT_NAME));
        }
        else {
            this.dispatchEvent(new CustomEvent(CLOSE_EVENT_NAME));
        }
    }
}
PlatformSection.properties = {
    ...NavItem.properties,
    isOpen: { type: Boolean, reflect: true, attribute: "is-open" },
    hideSummary: { type: Boolean, reflect: true, attribute: "hide-summary" },
};
PlatformSection.styles = [
    ...NavItem.styles,
    css `
      summary[hidden] {
        display: none;
      }
      summary[hidden] + ul {
        padding-top: 0;
      }
    `,
];
export const PLATFORM_SECTION_TAG = "atlas-gn-platform-section";
defineComponent(PLATFORM_SECTION_TAG, PlatformSection);
